export default "__VITE_ASSET__CX5gKLDY__"